/**
 * @file
 * Alert Bar JS file.
 */
(($, Drupal) => {
  Drupal.behaviors.gcsu_alert_bar = {
    attach(context) {
      function alertAnimation() {
        const element = $(".alert-bar", context);
        if (element.outerWidth() < element[0].scrollWidth) {
          element.addClass("alert-bar__text--animating");
        } else {
          element.removeClass("alert-bar__text--animating");
        }
      }

      if ($(".alert-bar", context).length) {
        $(window).on("resize", () => {
          alertAnimation();
        });

        alertAnimation();
      }
    }, // End of Drupal attach.
  };
})(jQuery, Drupal);
